<template>
  <div class="boxes">
    <div v-if="!onboardingHidden" class="dashboard-box informational">
      <OnboardSection/>
    </div>
    <div class="dashboard-box">
      <DesignSection/>
    </div>
    <div v-if="showTeamSection" class="dashboard-box">
      <TeamSection/>
    </div>
    <div class="dashboard-box social">
      <ShareSection/>
    </div>
  </div>
</template>

<script>
import WelcomeSection from './WelcomeSection';
import DesignSection from './DesignSection';
import OnboardSection from './OnboardSection';
import TeamSection from './TeamSection';
import ShareSection from './ShareSection';
import {mapGetters} from 'vuex';
export default {
  components: {
    WelcomeSection,
    DesignSection,
    OnboardSection,
    TeamSection,
    ShareSection
  },
  computed: {
    ...mapGetters(['onboardingHidden', 'flags', 'isAdmin']),
    showTeamSection() {
      return this.isAdmin || this.flags.showTeamTabToOrderers;
    }
  }
}
</script>

<style scoped lang="scss">
@import '~scss/colors';

.boxes {
  display: flex;
  flex-flow: row wrap;
  margin: -0.5rem;
  @media screen and (max-width: 575.98px) {
    // On mobile, shrink borders in
    margin: 0.5rem 0.5rem calc(60px + 0.5rem) 0.5rem;
  }
}
.dashboard-box {
  position: relative;
  width: calc(50% - 1rem);
  @media screen and (max-width: 767.98px) {
    // On iPad and mobile, show in one column
    width: 100%;
  }
  background: $white;
  border:1px solid rgb(192, 192, 192);
  padding: 1rem;
  margin: 0.5rem;
}
.full {
  // width: 100%;
  padding: 0;
}
.informational {
  background-color: #dee;
  padding: 1em;
  color: #434;
  border-color: #799;
}
.social {
  background-color: #edeceb;
}
</style>

<style lang="scss">
@import '~scss/colors.scss';

// Unscoped style shared among the boxes
.dashboard-box {
  h1, h2 {
    margin: 0;
  }
  h2 {
    padding-bottom: 0.5rem;
    border-bottom: 2px solid $red;
    margin-bottom: 1rem;
    font-size: 1rem;
  }
  &.informational h1 {
    color: $gray-0;
    font-size: 1.5em;
    font-weight: normal;
    text-transform: uppercase;
    margin: 0 0 1em 0;
    letter-spacing: 0.2em;
    padding: 0 0 0.5em 0;
    border-bottom: 5px solid $red;
  }

  .cta-link {
    position: absolute;
    right: 1.2em;
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-align: right;
    margin: 0;
  }
  .cta-link.minor {
    top: 1em;
    font-size: 0.8rem;
    color: $red;
  }

  .basic-tooltip {
    opacity: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 10px;
    padding: 0px 10px 0 10px;
    text-align: center;
    background: #cee;
    font-size: 1em;
    color: black;
    border-top: 4px solid #acc;
    line-height: 2em;
    border-radius: 3px;
    box-shadow: 0px 4px 12px 4px rgba(0,0,0,0.1);
    z-index: 2;

    &.show {
      opacity: 1;
    }
  }
  .basic-tooltip::after {
    position: absolute;
    top: -23px;
    border: 10px solid transparent;
    border-bottom-color: #acc;
    left: 50%;
    transform: translateX(-50%);
    content:""
  }
  p a {
    // Link in para
    color: $red;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/home/Home.vue